import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, Col, Container, Modal, Row, Form } from "react-bootstrap"
import { getPaymentMethods, importPaymentMethodFromEbroker } from "../../actions/other/receiptsActions"
import { RootState, AppDispatch } from "../../store"
import { CustomDataTable } from "../../components/design/Datatables/CustomDataTable"
import { useAuth } from "../../components/auth/useAuth"
import { useTranslation } from "react-i18next"
import Swal from "sweetalert2"

export interface PaymentMethod {
    _id?: string
    name?: string
    ebrokerId?: number
}

export default function ReceiptPaymentMethod() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch: AppDispatch = useDispatch()

    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(25)
    const [search, setSearch] = useState<string>("")
    const [totalRows, setTotalRows] = useState<number>(0)

    const { paymentMethods, loadingPaymentMethods } = useSelector((state: RootState) => state.receipts)

    useEffect(() => {
        if (clientauth) {
            dispatch(getPaymentMethods() as any)
        }
    }, [dispatch, t, clientauth])

    const handleImportPaymentMethods = () => {
        Swal.fire({
            icon: 'question',
            title: t('receiptTranslate.importPaymentMethods')!,
            text: t('receiptTranslate.importPaymentMethodsAreYouSure')!,
            showDenyButton: true,
            confirmButtonText: t('global.ok')!,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(importPaymentMethodFromEbroker())
            }
        })
    }

    const columnsPaymentMethods = [
        {
            name: t("receiptTranslate.ebrokerId"),
            selector: (receipt: PaymentMethod) => receipt.ebrokerId?.toString() || "-",
            sortable: true,
            maxWidth: "160px",
            center: true,
        },
        {
            name: t("receiptTranslate.name"),
            selector: (receipt: PaymentMethod) => receipt.name || "",
            sortable: true,
            wrap: true,
        }
    ]


    return (
        <Container className='p-1 py-5 p-md-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('menus.paymentMethods')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <button className="btn btn-primary" onClick={handleImportPaymentMethods}>
                        {t("receiptTranslate.importPaymentMethodsFromEbroker")}
                    </button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    {loadingPaymentMethods ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                            <div className="spinner-border" role="status"></div>
                                                <span className="sr-only">{t("global.loading")}</span>
                                        </div>
                                    ) : paymentMethods?.length > 0 ? (
                                        <CustomDataTable
                                            columns={columnsPaymentMethods}
                                            data={paymentMethods}
                                            search={search}
                                            setSearch={setSearch}
                                            page={page}
                                            setPage={setPage}
                                            limit={limit}
                                        />
                                    ) : (
                                        <h4 className="mt-4">{t("receiptTranslate.thereisnotpaymentMethods")}</h4>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}